var _style, _polyline, _polyline2, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStackMotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 204 220",
    style: {
      enableBackground: "new 0 0 204 220"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0;fill:none;stroke:#000000;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st1{opacity:0;fill:none;stroke:#000000;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st2{opacity:0;fill:none;stroke:#000000;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;}\r\n\r\n\t.st0{\r\n    \tanimation:fadeIn 700ms 200ms cubic-bezier(0.075, 0.82, 0.165, 1) forwards;\r\n\t}\r\n\r\n\t.st1{\r\n    \tanimation:fadeIn 700ms 300ms cubic-bezier(0.075, 0.82, 0.165, 1) forwards;\r\n\t}\r\n\r\n\t.st2{\r\n    \tanimation:fadeIn 700ms 400ms cubic-bezier(0.075, 0.82, 0.165, 1) forwards;\r\n\t}\r\n\r\n\t@keyframes fadeIn {\r\n    \t0%{\r\n    \t    transform: translateY(100px);\r\n    \t    opacity: 0;\r\n    \t}\r\n    \t100%{\r\n    \t    transform: translateY(0px);\r\n    \t    opacity: 1;\r\n    \t}\r\n\t}\r\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "6,158 102,214 198,158 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "6,110 102,166 198,110 "
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "6,62 102,118 198,62 102,6 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackMotion);
export default __webpack_public_path__ + "static/media/stack_motion.5ecc15728cc518dec776de845a8fdcea.svg";
export { ForwardRef as ReactComponent };